import { apiUrl } from "../enviroments/enviroments.dev";
import { LatestResponse } from "../models/Receipts";
import { Api } from "./Api";

const targetTransactions    = "/transactions";
const targetPurchases       = "/purchases";
const targetPayments        = "/payments";
const targetDeposits        = "/deposits";
const targetInvoices        = "/invoices";

const target                = "/receipts";

export class ReceiptsService {
    public static getReceiptsByType (string:String) {
        console.dir(Api);
    }

    public static getLatest (id:number, entity: string, pagina:number) : Promise<LatestResponse> {
        let path = '';
        if (entity === 'all') path = targetTransactions;
        if (entity === 'purchases') path = targetPurchases;
        if (entity === 'payments') path = targetPayments;
        if (entity === 'deposits') path = targetDeposits;
        if (entity === 'invoices') path = targetInvoices;
        // Envios = valores que a empresa pagou pra fora em nome do cliente
        // (sub-rota de invoices). Diferente de "Saques" (=/invoices direto),
        // que sao pedidos de saque do cliente.
        if (entity === 'shipments') path = targetInvoices + "/client-shipments";
        path += `/${id}/latest?pagina=${pagina}`;
        return Api.get(apiUrl(path));
    }


    public static sendOrder (payload:{ formData:FormData,user_id:number,organization_id:number}) {
        return Api.post(apiUrl(target+"/"+payload.organization_id+"/upload-order/"+payload.user_id), payload.formData);
    }

    public static getOrders(id:number) : Promise<LatestResponse> {
        return Api.get(apiUrl(target+"/"+id+"/orders"))
    }
}
